<template lang="pug">
  div.p-header
    img(:src="logo" alt="логотип")
</template>

<script>
  import logo from './assets/logo.png';
  export default {
    name: 'PageHeader',
    data: function () {
      return {
        logo: logo
      }
    }
  }
</script>

<style lang="scss" src="./assets/page-header.scss"></style>
